import { colors } from '@ctw/config/zui';
import { StyleSheet } from '@react-pdf/renderer';

// Define styles for the PDF
// This file is separate from pdf-cda-renderer.tsx to avoid pulling in zui-provider
// when bff-api imports globalStyles (which is a Node.js environment)
export const globalStyles = StyleSheet.create({
  page: {
    padding: 30,
    fontWeight: 400,
    gap: 7,
    paddingBottom: 75,
    fontSize: 11,
  },
  container: {
    marginBottom: 10,
    flexGrow: 1,
    fontSize: 11,
  },
  text: {
    fontSize: 11,
    lineHeight: 1.5,
    display: 'flex',
  },
  link: {
    color: '#036240',
    textDecoration: 'none',
  },
  title: {
    fontWeight: 400,
    fontSize: 14,
  },
  alertBox: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    marginBottom: 10,
    borderWidth: 1,
    paddingHorizontal: 8,
    paddingVertical: 7,
    borderColor: colors.caution.badge,
    backgroundColor: colors.caution.background,
    fontWeight: 400,
    fontSize: 11,
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    borderBottomLeftRadius: 6,
    borderBottomRightRadius: 6,
  },
  alertText: {
    color: colors.caution.text,
    fontWeight: 400,
    fontSize: 11,
  },
  infoBox: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    marginBottom: 10,
    borderWidth: 1,
    paddingHorizontal: 8,
    paddingVertical: 7,
    borderColor: colors.info.badge,
    backgroundColor: colors.info.background,
    fontWeight: 400,
    fontSize: 11,
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    borderBottomLeftRadius: 6,
    borderBottomRightRadius: 6,
  },
  infoText: {
    color: colors.info.text,
    fontWeight: 400,
    fontSize: 11,
  },
  footer: {
    borderTop: 'solid',
    borderTopWidth: 1,
    borderTopColor: colors.background.disabled,
    paddingTop: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    position: 'absolute',
    bottom: 25,
    left: 30,
    right: 30,
    textAlign: 'center',
    color: colors.meta.text,
    fontSize: 10,
  },
  footerMetadata: {
    display: 'flex',
    flexDirection: 'column',
    color: colors.meta.text,
    fontSize: 10,
    paddingRight: 13,
  },
  footerContext: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    color: colors.meta.text,
    fontSize: 10,
    paddingRight: 13,
  },
  footerTitle: {
    textAlign: 'left',
    color: colors.meta.text,
    fontSize: 10,
  },
  footerFields: {
    textAlign: 'center',
    color: colors.meta.text,
    fontSize: 10,
  },
  footerPageNumber: {
    textAlign: 'right',
    color: colors.meta.text,
    fontSize: 10,
  },
  footerAttribution: {
    textAlign: 'right',
    color: colors.meta.text,
    fontSize: 12,
  },
});
